import styled from 'utils/styled';

export const Container = styled.div`
  .site-layout .site-layout-background {
    background: #fff;
  }

  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export const LogoContainer = styled.div`
  height: 32px;
  margin: 16px;
  /* background: rgba(255, 255, 255, 0.3); */

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LogoutButtonContainer = styled.div`
  margin: auto;

  margin-bottom: 16px;
`;

export const Logo = styled.img`
  width: 100%;
  object-fit: contain;
`;
